import { Injectable } from "@angular/core";
import { NetworkService } from "../../common/network.service";

@Injectable()
export class CourseManagementService {
  constructor(private _networkService: NetworkService) { }

  getCourseList() {
    return this._networkService.get("api/course/v1", null, null, "bearer");
  }
  getCourseById(query) {
    return this._networkService.get("api/course/v1?" + query, null, null, "bearer");
  }
  saveCourse(body: any) {
    return this._networkService.post("api/course/", body, null, "bearer");
  }
  updateCourse(body: any) {
    return this._networkService.put("api/course/", body, null, "bearer");
  }
  deleteCourse(id: any) {
    return this._networkService.delete("api/course/" + id, null, "bearer")
  }
  uploadImage(image: File) {
    const formData = new FormData();

    formData.append("image", image);
    return this._networkService.uploadImages("api/s3upload/", formData, null, "bearer");
  }

  uploadVideo(video: File) {
    const formData = new FormData();

    formData.append("image", video);
    return this._networkService.uploadImages("api/s3upload/", formData, null, "bearer");
  }

  uploadAudio(audio: File) {
    const formData = new FormData();

    formData.append("image", audio);
    return this._networkService.uploadImages("api/s3upload/", formData, null, "bearer");
  }

  saveCourseDetail(body: any) {
    return this._networkService.post("api/coursedetail", body, null, "bearer");
  }
  getlessonListById(query) {
    return this._networkService.get("api/coursedetail/" + query, null, null, "bearer");
  }
  deleteLesson(id: any) {
    return this._networkService.delete("api/coursedetail/" + id, null, "bearer")
  }

  getlessonDetailById(query) {
    return this._networkService.get("api/coursedetail/" + query, null, null, "bearer");
  }
  updateLessonById(body: any) {
    return this._networkService.put("api/coursedetail/", body, null, "bearer");
  }

  saveASR(body: any) {
    return this._networkService.post("api/asr/", body, null, "bearer");
  }
  editASR(body: any) {
    return this._networkService.put("api/asr/", body, null, "bearer");
  }
  getASRbyCourseWeek(query) {
    return this._networkService.get("api/asr/" + query, null, null, "bearer");
  }
}
